module.exports = __webpack_public_path__ + "img/college_headar.dded6030.jpg";